import { PASSWORD_CHECKS } from './passwordPolicy';

/** Checklist visual de requisitos, atualizado conforme o usuário digita. */
export function PasswordRequirements({ value }: { value: string }) {
  return (
    <ul className="mt-1.5 text-xs space-y-0.5">
      {PASSWORD_CHECKS.map((c) => {
        const ok = c.test(value);
        return (
          <li key={c.label} className={ok ? 'text-green-600' : 'text-gray-500'}>
            {ok ? '✓' : '•'} {c.label}
          </li>
        );
      })}
    </ul>
  );
}
